import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ModalController, NavController, Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class RouterService {
  constructor(
    private router: Router,
    private navCtrl: NavController,
    private platform: Platform,
    private modalController: ModalController
  ) {}
  public isMobile: boolean = false;

  goBack() {
    this.navCtrl.back();
    this.navCtrl.pop();
  }

  pop() {
    this.navCtrl.pop();
  }

  getRoutePrefix(): string {
    if (this.platform.is('desktop')) return '/mainview';
    return '/tabs/tab1';
  }

  routeToHome() {
    if (!this.isMobile) {
      this.router.navigateByUrl('/mainview/home', { replaceUrl: true });
    } else {
      this.router.navigateByUrl('/tabs/tab1', { replaceUrl: true });
    }
  }

  routeToDocumentViewer(id: string) {
    this.router.navigate(['/mainview/viewer/document'], {
      queryParams: {
        id: id,
      },
    });
  }

  routeToConstructionDayReportViewer(id: string) {
    this.router.navigate(['/mainview/viewer/construction-day-report'], {
      queryParams: {
        id: id,
      },
    });
  }

  routeToInspectionViewer(id: string) {
    this.router.navigate(['/mainview/viewer/inspection'], {
      queryParams: {
        id: id,
      },
    });
  }

  routeToHourOverviewViewer(id: string) {
    this.router.navigate(['/mainview/viewer/hour-overview'], {
      queryParams: {
        id: id,
      },
    });
  }

  routeToMachinery() {
    this.router.navigate(['/mainview/machinery-overview']);
  }

  routeToLogin() {
    this.router.navigate(['login']);
  }

  routeToSettings() {
    this.router.navigate(['/tabs/tab1/settings']);
  }

  routeToConstructionDayReportOverview() {
    this.router.navigate(['/mainview/construction-day-report-overview']);
  }

  routeToAbsenceOverview() {
    this.router.navigate(['/mainview/absence-overview']);
  }

  routeToTripReportOverview() {
    this.router.navigate(['/mainview/trip-overview']);
  }
}
